import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { collection, getDocs, doc, getDoc } from 'firebase/firestore';
import { db } from '../config/firebase';

export default function StudentVideos() {
  const { id: courseId } = useParams();
  const navigate = useNavigate();
  
  const [videoStatuses, setVideoStatuses] = useState({});
  const [selectedUnit, setSelectedUnit] = useState(1);
  const [loading, setLoading] = useState(true);

  // All 21 videos across 4 units
  const allVideos = [
    // Unit 1 - Episodes 1-14
    { id: 1, unit: 1, title: 'Episode 1', duration: '0 mins', url: 'https://drive.google.com/file/d/10r2MP0lI0C09_rdYWMJSP-NzRt7wLbZK/view?usp=sharing' },
    { id: 2, unit: 1, title: 'Episode 2', duration: '0 mins', url: 'https://drive.google.com/file/d/1NUEK4_wOosCCY1_-ccv5tOXVeZozvEWS/view?usp=sharing' },
    { id: 3, unit: 1, title: 'Episode 3', duration: '0 mins', url: 'https://drive.google.com/file/d/1E0ub8Jvxj-FlEEhwxJs-VxUybg5RfPA8/view?usp=sharing' },
    { id: 4, unit: 1, title: 'Episode 4', duration: '0 mins', url: 'https://drive.google.com/file/d/19Vk0Q0MfToon9F2VAbLZqUw5bGOSpMTD/view?usp=sharing' },
    { id: 5, unit: 1, title: 'Episode 5', duration: '0 mins', url: 'https://drive.google.com/file/d/16TXiD2HbeEN28kn_SRVG-Z_g-H6EOD2T/view?usp=sharing' },
    { id: 6, unit: 1, title: 'Episode 6', duration: '0 mins', url: 'https://drive.google.com/file/d/1id5Y_9AYermoHkcWLjlWDxEFHtR2Zabq/view?usp=sharing' },
    { id: 7, unit: 1, title: 'Episode 7', duration: '0 mins', url: 'https://drive.google.com/file/d/1xWrzO1IHnkeWhLdksz1b9n_5iSzhZ7Iq/view?usp=sharing' },
    { id: 8, unit: 1, title: 'Episode 8', duration: '0 mins', url: 'https://drive.google.com/file/d/1amh9u_vSXzdTdKUGGROOQPEjnDhhG_yN/view?usp=sharing' },
    { id: 9, unit: 1, title: 'Episode 9', duration: '0 mins', url: 'https://drive.google.com/file/d/1jbP09CInTTPcwvvMW-P8r_Z8yrrA8jF5/view?usp=sharing' },
    { id: 10, unit: 1, title: 'Episode 10', duration: '0 mins', url: 'https://drive.google.com/file/d/1N_jPObBgFctcIYo_AcS1jD8ohG1-3Eid/view?usp=sharing' },
    { id: 11, unit: 1, title: 'Episode 11', duration: '0 mins', url: 'https://drive.google.com/file/d/1Iy5t4YG-BTm4WuE1gRkF-Fr2BjBdKvB_/view?usp=sharing' },
    { id: 12, unit: 1, title: 'Episode 12', duration: '0 mins', url: 'https://drive.google.com/file/d/1O7cBqpvC6VysZGxVRIMdp0JFoXILz8WJ/view?usp=sharing' },
    { id: 13, unit: 1, title: 'Episode 13', duration: '0 mins', url: 'https://drive.google.com/file/d/1JOtU5EDD3Jt7Ky93F5MVqOkJ7vQSytOn/view?usp=sharing' },
    { id: 14, unit: 1, title: 'Episode 14', duration: '0 mins', url: 'https://drive.google.com/file/d/1iHQIet_tWYOpEKxrB6vgnh482421YJa1/view?usp=sharing' },
    
    // Unit 2 - Episodes 1-3
    { id: 15, unit: 2, title: 'Episode 1', duration: '0 mins', url: 'https://drive.google.com/file/d/1CB9K68hoEDeXBYnujKTF1nC5jr4ndSGt/view?usp=sharing' },
    { id: 16, unit: 2, title: 'Episode 2', duration: '0 mins', url: 'https://drive.google.com/file/d/1M5iEyBzx445ZUgxbrzKB1ufgWbx6_hbJ/view?usp=sharing' },
    { id: 17, unit: 2, title: 'Episode 3', duration: '0 mins', url: 'https://drive.google.com/file/d/1WJHjK2FVPUNMRoo7Tu5AYxAAdsVtoG3c/view?usp=sharing' },
    
    // Unit 3 - Episodes 1-2
    { id: 18, unit: 3, title: 'Episode 1', duration: '0 mins', url: 'https://drive.google.com/file/d/1NsMEasa0rgpIn4DZR4MHxwIDrHMjsJII/view?usp=sharing' },
    { id: 19, unit: 3, title: 'Episode 2', duration: '0 mins', url: 'https://drive.google.com/file/d/1Ou2P1MkCmhdKr3Rw2C2WQNB02iBsFTuW/view?usp=sharing' },
    
    // Unit 4 - Episodes 1-2
    { id: 20, unit: 4, title: 'Episode 1', duration: '0 mins', url: 'https://drive.google.com/file/d/1cNVt5BzcUDMhVkOBqcbcI79NBr84HZqy/view?usp=sharing' },
    { id: 21, unit: 4, title: 'Episode 2', duration: '0 mins', url: 'https://drive.google.com/file/d/1DjSGss47ugUFuS403KiPsuOYrIg5oteb/view?usp=sharing' }
  ];

  // Load all instructor statuses
  useEffect(() => {
    const loadInstructorStatuses = async () => {
      try {
        const instructorsRef = collection(db, 'instructors');
        const instructorDocs = await getDocs(instructorsRef);
        
        let allStatuses = {};

        for (const instructorDoc of instructorDocs.docs) {
          const statusRef = doc(db, 'instructors', instructorDoc.id, 'videoStatuses', 'statuses');
          const statusSnap = await getDoc(statusRef);
          
          if (statusSnap.exists()) {
            Object.assign(allStatuses, statusSnap.data());
          }
        }

        setVideoStatuses(allStatuses);
        setLoading(false);
      } catch (error) {
        console.error('Error loading video statuses:', error);
        setLoading(false);
      }
    };

    loadInstructorStatuses();
  }, []);

  // Get videos for current unit that are released
  const unitVideos = allVideos
    .filter(v => v.unit === selectedUnit)
    .filter(v => videoStatuses[`video_${v.id}`] === 'released');

  const unitCounts = {
    1: 14,
    2: 3,
    3: 2,
    4: 2
  };

  if (loading) {
    return (
      <div style={{ padding: '3rem', textAlign: 'center' }}>
        <p>Loading videos...</p>
      </div>
    );
  }

  return (
    <div style={{ background: '#ffffff', minHeight: 'calc(100vh - 70px)', padding: '3rem 2rem' }}>
      <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
        {/* Back Button */}
        <button
          onClick={() => navigate(`/course/${courseId}`)}
          style={{
            background: '#e8e8e8',
            border: 'none',
            color: '#1a1a1a',
            padding: '0.6rem 0.8rem',
            borderRadius: '6px',
            cursor: 'pointer',
            fontSize: '1.1rem',
            transition: 'all 300ms ease',
            marginBottom: '2rem'
          }}
          onMouseOver={(e) => {
            e.target.style.background = '#d0d0d0';
          }}
          onMouseOut={(e) => {
            e.target.style.background = '#e8e8e8';
          }}
        >
          <i className="fas fa-arrow-left"></i>
        </button>

        {/* Header */}
        <div style={{ marginBottom: '3rem', paddingBottom: '1.5rem', borderBottom: '2px solid #e8e8e8' }}>
          <h1 style={{ fontSize: '2.5rem', fontWeight: 700, color: '#1a1a1a', margin: '0' }}>
            <i className="fas fa-video" style={{ marginRight: '1rem' }}></i>
            Course Videos
          </h1>
          <p style={{ fontSize: '1rem', color: '#666', margin: '0.5rem 0 0 0' }}>
            Watch course videos released by your instructor
          </p>
        </div>

        {/* Unit Selection Tabs */}
        <div style={{ display: 'flex', gap: '1rem', marginBottom: '2rem', borderBottom: '2px solid #e8e8e8', paddingBottom: '1rem', overflowX: 'auto' }}>
          {[1, 2, 3, 4].map((unit) => (
            <button
              key={unit}
              onClick={() => setSelectedUnit(unit)}
              style={{
                padding: '0.75rem 1.5rem',
                borderRadius: '6px',
                border: 'none',
                fontWeight: 600,
                cursor: 'pointer',
                fontSize: '1rem',
                transition: 'all 0.3s ease',
                background: selectedUnit === unit ? '#1a1a1a' : '#f5f5f5',
                color: selectedUnit === unit ? '#fff' : '#1a1a1a',
                whiteSpace: 'nowrap'
              }}
              onMouseOver={(e) => {
                if (selectedUnit !== unit) {
                  e.target.style.background = '#e8e8e8';
                }
              }}
              onMouseOut={(e) => {
                if (selectedUnit !== unit) {
                  e.target.style.background = '#f5f5f5';
                }
              }}
            >
              Unit {unit}
            </button>
          ))}
        </div>

        {/* Videos Grid */}
        <div style={{ marginBottom: '3rem' }}>
          <div style={{ marginBottom: '1.5rem', display: 'flex', alignItems: 'center', gap: '1rem' }}>
            <h2 style={{ fontSize: '1.75rem', fontWeight: 700, color: '#1a1a1a', margin: 0 }}>
              Unit {selectedUnit} Videos
            </h2>
            <span style={{ background: '#1a1a1a', color: '#fff', padding: '0.5rem 1rem', borderRadius: '20px', fontSize: '0.9rem', fontWeight: 600 }}>
              {unitVideos.length} of {unitCounts[selectedUnit]} released
            </span>
          </div>

          {unitVideos.length === 0 ? (
            <div style={{ background: '#f9f9f9', border: '2px dashed #e8e8e8', borderRadius: '8px', padding: '3rem', textAlign: 'center' }}>
              <i className="fas fa-lock" style={{ fontSize: '2rem', color: '#999', marginBottom: '1rem', display: 'block' }}></i>
              <p style={{ fontSize: '1.1rem', color: '#666', margin: 0 }}>
                No videos released yet for this unit. Check back soon!
              </p>
            </div>
          ) : (
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))', gap: '1.5rem' }}>
              {unitVideos.map((video) => (
                <div
                  key={video.id}
                  style={{
                    background: '#fff',
                    border: '1px solid #e8e8e8',
                    borderRadius: '10px',
                    overflow: 'hidden',
                    transition: 'all 0.3s ease',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
                    cursor: 'pointer'
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.boxShadow = '0 8px 24px rgba(0,0,0,0.12)';
                    e.currentTarget.style.transform = 'translateY(-4px)';
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.04)';
                    e.currentTarget.style.transform = 'translateY(0)';
                  }}
                  onClick={() => window.open(video.url, '_blank')}
                >
                  <div style={{ background: '#1a1a1a', color: '#fff', padding: '1.5rem', minHeight: '100px', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                    <h3 style={{ margin: 0, fontSize: '1.2rem', fontWeight: 700 }}>
                      {video.title}
                    </h3>
                    <p style={{ margin: '0.5rem 0 0 0', fontSize: '0.95rem', opacity: 0.9 }}>
                      <i className="fas fa-clock" style={{ marginRight: '0.5rem' }}></i>
                      {video.duration}
                    </p>
                  </div>

                  <div style={{ padding: '1.5rem' }}>
                    <div style={{ marginBottom: '1rem' }}>
                      <span style={{
                        display: 'inline-block',
                        background: '#e8f5e9',
                        color: '#2e7d32',
                        padding: '0.5rem 1rem',
                        borderRadius: '20px',
                        fontSize: '0.85rem',
                        fontWeight: 600
                      }}>
                        ● Released
                      </span>
                    </div>

                    <button
                      style={{
                        width: '100%',
                        background: '#1a1a1a',
                        color: '#fff',
                        border: 'none',
                        padding: '0.75rem',
                        borderRadius: '6px',
                        fontWeight: 600,
                        cursor: 'pointer',
                        fontSize: '0.95rem',
                        transition: 'all 0.3s ease'
                      }}
                      onMouseOver={(e) => e.target.style.opacity = '0.8'}
                      onMouseOut={(e) => e.target.style.opacity = '1'}
                    >
                      <i className="fas fa-play" style={{ marginRight: '0.5rem' }}></i>
                      Watch Video
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Info Box */}
        <div style={{ background: '#f0f4ff', border: 'left: 4px solid #667eea', borderLeft: '4px solid #667eea', borderRadius: '6px', padding: '1.5rem' }}>
          <p style={{ margin: 0, color: '#1a1a1a', fontSize: '0.95rem' }}>
            <i className="fas fa-info-circle" style={{ marginRight: '0.75rem', color: '#667eea' }}></i>
            <strong>Videos below are locked</strong> — Your instructor will release them when ready. Check back regularly!
          </p>
        </div>
      </div>
    </div>
  );
}
